import type { TranslationMessages } from '../types';

export const policies: TranslationMessages = {
  name: 'Chính sách |||| Chính sách',
  title: 'Quản lý Chính sách',
  subtitle: 'Quản lý chính sách và trích xuất chúng từ lịch sử trò chuyện',
  create: 'Tạo Chính sách',
  consent: 'Tôi Đồng ý',
  consented: 'Bạn đã đồng ý với chính sách này',
  consent_success: 'Bạn đã đồng ý với chính sách này',
  consent_failed: 'Không thể đồng ý với chính sách',
  ask_question: 'Đặt Câu hỏi',
  ask_question_desc: 'Đặt câu hỏi về: {{title}}',
  question: 'Câu hỏi',
  question_placeholder: 'Nhập câu hỏi của bạn về chính sách này...',
  question_required: 'Vui lòng nhập câu hỏi',
  question_submitted: 'Câu hỏi của bạn đã được gửi',
  question_failed: 'Không thể gửi câu hỏi',
  submit_question: 'Gửi Câu hỏi',
  your_questions: 'Câu hỏi của Bạn',
  answer: 'Câu trả lời',
  pending_answer: 'Đang chờ câu trả lời...',
  question_type: 'Loại Câu hỏi',
  ask_ai: 'Hỏi Trợ lý AI',
  ask_manager: 'Hỏi Quản lý',
  ai_desc: 'Nhận câu trả lời tức thì từ trợ lý AI',
  manager_desc: 'Gửi câu hỏi của bạn để quản lý trả lời',
  asking_ai: 'Đang hỏi AI...',
  ai_answer: 'AI',
  ai_answer_label: 'Câu trả lời AI',
  ai_answer_received: 'Trợ lý AI đã trả lời câu hỏi của bạn',
  pending: 'Đang chờ',
  continue_conversation: 'Tiếp tục Cuộc trò chuyện',
  conversation_history: 'Lịch sử Cuộc trò chuyện',
  you: 'Bạn',
  ai: 'AI',
  max_messages_reached:
    'Bạn đã đạt đến số lượng tin nhắn tối đa (10). Vui lòng hỏi quản lý trực tiếp để được hỗ trợ thêm.',
  max_messages_warning:
    'Bạn đã đạt đến số lượng tin nhắn tối đa. Vui lòng hỏi quản lý trực tiếp.',
  send_message: 'Gửi Tin nhắn',
  ai_continue_desc: 'Tiếp tục cuộc trò chuyện với trợ lý AI',
  edit: 'Chỉnh sửa Chính sách',
  delete: 'Xóa Chính sách',
  update: 'Cập nhật Chính sách',
  search: 'Tìm kiếm chính sách...',
  all: 'Tất cả',
  active_only: 'Hoạt động',
  inactive_only: 'Không hoạt động',
  total: 'Tổng số Chính sách',
  active: 'Hoạt động',
  inactive: 'Không hoạt động',
  from_chat: 'Từ Trò chuyện',
  no_policies: 'Không tìm thấy Chính sách',
  create_first: 'Tạo chính sách đầu tiên của bạn hoặc trích xuất từ lịch sử trò chuyện',
  load_failed: 'Không thể tải chính sách',
  created: 'Tạo chính sách thành công',
  updated: 'Cập nhật chính sách thành công',
  deleted: 'Xóa chính sách thành công',
  create_failed: 'Không thể tạo chính sách',
  update_failed: 'Không thể cập nhật chính sách',
  delete_failed: 'Không thể xóa chính sách',
  validation_error: 'Vui lòng điền vào tất cả các trường bắt buộc',
  delete_confirmation:
    'Bạn có chắc chắn muốn xóa chính sách này? Hành động này không thể hoàn tác.',
  extract_from_chat: 'Trích xuất từ Trò chuyện',
  extracting: 'Đang trích xuất...',
  extract_description:
    'Xem lại lịch sử trò chuyện và tạo chính sách từ tin nhắn trợ lý',
  no_chat_history: 'Không tìm thấy lịch sử trò chuyện',
  no_policies_in_chat: 'Không tìm thấy chính sách trong lịch sử trò chuyện',
  extract_failed: 'Không thể trích xuất từ trò chuyện',
  chat_messages_count: 'Tìm thấy %{count} tin nhắn trong lịch sử trò chuyện',
  use_as_policy: 'Sử dụng làm Chính sách',
  title_label: 'Tiêu đề',
  title_placeholder: 'Nhập tiêu đề chính sách',
  description_label: 'Mô tả',
  description_placeholder: 'Nhập mô tả (tùy chọn)',
  content_label: 'Nội dung',
  content_placeholder: 'Nhập nội dung chính sách',
  applicable_processes_label: 'Quy trình Áp dụng',
  process_placeholder: 'Nhập tên quy trình và nhấn Enter',
  tags_label: 'Thẻ',
  tag_placeholder: 'Nhập thẻ và nhấn Enter',
  is_active: 'Hoạt động',
  priority_label: 'Ưu tiên',
  add: 'Thêm',
  create_description: 'Tạo chính sách mới có thể được sử dụng bởi chatbot',
  edit_description: 'Cập nhật thông tin chính sách',
  ai_extract: 'AI Trích xuất Siêu dữ liệu',
  extracting_metadata: 'Đang trích xuất...',
  ai_extract_hint:
    'Nhập nội dung chính sách của bạn và nhấp "AI Trích xuất Siêu dữ liệu" để tự động điền tiêu đề, mô tả, quy trình và thẻ',
  metadata_extracted: 'Trích xuất siêu dữ liệu chính sách thành công',
  extract_metadata_failed: 'Không thể trích xuất siêu dữ liệu: {{error}}',
  no_content_for_extraction: 'Vui lòng nhập nội dung chính sách trước',
  ai_rewrite: 'AI Viết lại',
  rewriting: 'Đang viết lại...',
  rewritten_content: 'Nội dung Đã viết lại',
  improvements: 'Cải thiện:',
  approve: 'Phê duyệt',
  reject: 'Từ chối',
  content_rewritten:
    'Viết lại nội dung thành công. Xem xét và phê duyệt hoặc từ chối các thay đổi.',
  rewrite_failed: 'Không thể viết lại nội dung: {{error}}',
  rewrite_approved: 'Nội dung đã viết lại được phê duyệt và áp dụng',
  rewrite_rejected: 'Nội dung đã viết lại bị từ chối',
  no_content_for_rewrite: 'Vui lòng nhập nội dung chính sách trước',
};
